import { request } from './request'

// 订单列表
export const getOrderList = (params) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/page',
    data: params
  })
}
// 订单详情
export const getOrderDetail = (params, notMsg = false) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/order/views',
    params,
    notMsg
  })
}
// 订单退款详情
export const getOrderRefundDetail = (id) => {
  return request({
    method: 'get',
    url: `/ocean/api/v1/order/refund/${id}`,
  })
}
// 提交退款
export const postRefund = (data, id) => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/order/refund/${id}`,
    data
  })
}
// 订单详情
export const modifyRemark = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/order/remarkModify',
    data
  })
}

// 发货详情
export const getShipmentDetail = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/order/preDelivery',
    params
  })
}

// 发货
export const orderDelivery = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/delivery',
    data
  })
}
// 订单导出
export const orderReportDownload = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/export',
    data,
    csv: true
  })
}


// 修改物流信息
export const modifyShipment = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/order/deliveryUpdate',
    data
  })
}

// 订单导出
export const exportOrder = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/exports',
    data
  })
}

// 订单导出进度查询
export const queryExportOrderStatus = (taskId) => {
  const url = `/ocean/api/v1/order/exports/${taskId}`
  return request({
    method: 'get',
    url
  })
}

// 订单utm信息查询
export const queryOrderUtm = (params,) => {
  const url = '/ocean/api/v1/order/utm/chain'
  return request({
    coverData: false,
    method: 'get',
    url,
    params
  })
}

// 获取商家列表
export const getShopList = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/shop/select',
    // params
  })
}

// 取消订单接口
export const getCancelOrder = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/order/cancel',
    params
  })
}

// 订单发货信息查询
export const getOrderSendMessage = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/order/deliver/views',
    params
  })
}

// 获取订单发货物流商
export const getSendDeliver = data => {
  const url = '/ocean/api/v1/order/shipping/list'
  return request({
    method: 'get',
    url,
    data
  })
}
// 获取所有国家
export const getAllCountry = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/order/address/country/list',
  })
}

// 获取省份
export const getProvince = countryCode => {
  return request({
    method: 'get',
    url: `/ocean/api/v1/order/address/position/${countryCode}`,
  })
}

// 获取城市
export const getCity = (countryCode, code) => {
  return request({
    method: 'get',
    url: `/ocean/api/v1/order/address/position/${countryCode}/${code}`,
  })
}

// 订单客户信息更新
export const updateCustomerData = data => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/order/customer/update',
    data
  })
}

// 发货接口
export const putSend = data => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/order/deliver',
    data
  })
}
// 订单标记已妥投
export const putOrderDelivery = data => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/order/delivery',
    data
  })
}

// 查询paypal账号列表
export const getPaypalAccountList = data => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/paypal/select/account',
    data
  })
}
// 修改paypal账号
export const updatePaypalAccount = data => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/paypal/update/account',
    data
  })
}
// 新增paypal账号
export const addPaypalAccount = data => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/order/paypal/create/account',
    data
  })
}
// 云途物流价格查询
export const getYuntuFee = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/yuntu/query/fee/list',
    params,
    notMsg: true
  })
}
// 编辑未识别物流商
export const updateFulfillment = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/order/update/fulfillment',
    params,
  })
}
// 递四方价格查询
export const getD4pxFee = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/d4px/query/fee/list',
    params,
  })
}
// 物流价格查询
export const getLogisticsFee = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/d4px/query/fee/listMap',
    params,
  })
}
